module.exports = __webpack_public_path__ + "img/bg.71b95dfd.jpg";